import React from "react";
import { Tooltip } from "@mui/material";
import HlxButton from "component/commonComponents/button/button";
import * as AppIcons from "component/commonComponents/Icon";
import { DashboardIcon } from "component/commonComponents/Icon";
import { StyledQuickLinkIcon, StyledQuickLinkCard, StyledTitle } from "./quickLinksCard.style";
import * as muiIcon from "@mui/icons-material";
import images from './images';
import parse from 'html-react-parser';
import { handleKeyPress } from "utils/functions";

export interface Icon {
    /**
     * Type of icon to display
     * @default 'app'
     * @app => icon of commonComponents/Icon. Example: 'LockIcon'
     * @mui => icon of material-ui. Example: 'Business'
     * @assets => icon of internal file. Example: import OutLook from './icon-microsoft-outlook.png'  
     * @url => icon url. Example: https://via.placeholder.com/150
     */
    type: "app" | "mui" | "url" | 'assets';
    value: string;
    onClickIcon?: () => void;
    isShadow?: boolean;
    key: string;
    props?: any;
}

export interface IQuickLinkCardProps {
  title: string;
  subTitle: () => string;
  labelButton: string;
  icons: Icon[];
  onClick: () => void;
  showButton: boolean;
  iconShadow?: boolean;
  onClickOnIcon: (icon: Icon) => void;
  isSubtitleBold?: boolean;
  isEmptyCard?: boolean;
}

const QuickLinkCard = (props: IQuickLinkCardProps) => {
  const { title, subTitle, labelButton, onClick, icons, showButton, onClickOnIcon, isSubtitleBold, isEmptyCard = false } = props;

  const isCheckLongText = labelButton.length > 17 ? true : false;

  const renderIcon = (icon: Icon) => {
    if (!icon || !icon.value) {
      return null;
    }
    switch (icon.type) {
      case "app":
        const AppIcon = AppIcons[icon.value as keyof typeof AppIcons];
        return <AppIcon kind="primary" aria-label="quicklink"/>;
      case "mui":
        try {
          const MuiIcon = muiIcon[icon.value as keyof typeof muiIcon]
          return (MuiIcon && <MuiIcon  aria-label="quicklink" />)
        } catch (error) {
          return null;
        }
      case "assets":
        const image = images[icon.value as keyof typeof images]
        return (<img src={image} aria-label={icon.value} className="quicklink-image" title={icon.value} />)
      case "url":
        return (
          <img src={icon.value} aria-label="quicklink" className="quicklink-image" title="Quick Link" />
        );
      default:
        return <DashboardIcon kind="secondary" alt="quicklink" />;
    }
  };

  const subtitle = parse(subTitle());

  return (
    <StyledQuickLinkCard $disabled={isEmptyCard} tabIndex={0} onKeyDown={(e: any) => handleKeyPress(e, 'Enter', onClick)} onClick={onClick}>
        {
          icons && icons.length > 0 && (
            <div className="card-icons"  aria-label="Card Icons">
              {
                icons.map((icon, index) => (
                  <StyledQuickLinkIcon role="button" className="icon" key={index} shadow={icon.isShadow} props={icon?.props} onClick={() => onClickOnIcon(icon)} id={`img-quicklinkcard-icon`}  aria-label="Card Icon item">{renderIcon(icon)}</StyledQuickLinkIcon>
                ))
              }
            </div>
          )
        }
        <StyledTitle isSubtitleBold={isSubtitleBold} showButton={showButton}>
          <Tooltip title={title} placement="top-start">
            <div className="title" id={`lbl-quicklinkcard-title`}>{title}</div>
          </Tooltip>
          {!!subTitle() && <Tooltip title={subtitle} placement="top-start">
            <div className="subtitle" id={`lbl-quicklinkcard-sub_title`}>{subtitle}</div>
          </Tooltip>}
        </StyledTitle>
        {showButton && (
          <Tooltip title={isCheckLongText ? labelButton : ""} placement="top-start">
            <div className={`btn-link ${isCheckLongText ? "long-txt" : ""}`}>
              <HlxButton
                label={labelButton}
                onClick={(e: any) => {
                  e.stopPropagation();
                  onClick();
                }}
              />
            </div>
          </Tooltip>
        )}
    </StyledQuickLinkCard>
  );
};

export const defaultProps: IQuickLinkCardProps = {
  title: "Company Portal",
  subTitle: () => "Manage your company's portal",
  labelButton: "Click here",
  icons: [{
    type: "mui",
    value: "Business",
    key:"business",
  }],
  onClickOnIcon: (key) => {},
  onClick: () => {},
  showButton: true,
  isEmptyCard: false,
};

QuickLinkCard.defaultProps = defaultProps;

export default QuickLinkCard;

// const QuickLinkCard = () => {
//   return (
//     <div>Quick Card</div>
//   )
// }

// export default QuickLinkCard;